import Vue               from 'vue'
import VueRouter         from 'vue-router'
import StringTranslation from './string-translation.vue'
import TranslationTab    from './components/string-translation/translation-tab.vue'

Vue.use( VueRouter )

var trp_paths = []
for ( var trp_path_index in trp_string_translation_data.string_types_config ) {
    if ( trp_string_translation_data.string_types_config[ trp_path_index ][ 'category_based' ] ){
        trp_paths.push( {
                            path      : '/' + trp_path_index + '/',
                            component : TranslationTab,
                            props     : {
                                translationTab        : true,
                                translationType       : Object.keys( trp_string_translation_data.string_types_config[ trp_path_index ].categories )[ 0 ],
                                currentTab            : trp_string_translation_data.string_types_config[ trp_path_index ].categories[ Object.keys( trp_string_translation_data.string_types_config[ trp_path_index ].categories )[ 0 ] ],
                                parentTab             : trp_string_translation_data.string_types_config[ trp_path_index ],
                                parentTranslationType : trp_path_index
                            }
                        } )
        for ( var trp_path_category_index in trp_string_translation_data.string_types_config[ trp_path_index ].categories ) {
            trp_paths.push( {
                                path      : '/' + trp_path_index + '/' + trp_path_category_index + '/',
                                component : TranslationTab,
                                props     : {
                                    translationTab        : true,
                                    translationType       : trp_path_category_index,
                                    currentTab            : trp_string_translation_data.string_types_config[ trp_path_index ].categories[ trp_path_category_index ],
                                    parentTab             : trp_string_translation_data.string_types_config[ trp_path_index ],
                                    parentTranslationType : trp_path_index
                                }
                            } )
        }
    } else {
        trp_paths.push( {
                            path      : '/' + trp_path_index + '/',
                            component : TranslationTab,
                            props     : {
                                translationTab        : true,
                                translationType       : trp_path_index,
                                currentTab            : trp_string_translation_data.string_types_config[ trp_path_index ],
                                parentTab             : false,
                                parentTranslationType : false
                            }

                        } )
    }
}

// redirect all unregistered paths to first path
var first_tab = trp_paths[0]
first_tab.path = '*'
trp_paths.push(first_tab)

/** Future use **/
// trp_paths.push(
//     { path : '/import-export/', component : ImportExport, props : {} }
// )

const router = new VueRouter( {
                                  'routes'             : trp_paths,
                                  linkExactActiveClass : 'nav-tab-exact-active',
                                  linkActiveClass      : 'nav-tab-active'
                              } )


if ( document.getElementById( 'trp-editor-container' ) ){

    window.tpStringTranslationApp = new Vue( {
                                                 components : {
                                                     'trp-string-translation' : StringTranslation
                                                 },
                                                 el         : '#trp-editor-container',
                                                 data       : {},
                                                 router
                                             } )

}
